import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';


export const standardsProgressApi = createApi({
  reducerPath: 'standardsProgressApi',
  baseQuery,
  tagTypes: ['StudentProgress'],
  endpoints: builder => ({
    getStudentStandardsProgress: builder.query<
      StudentProgress,
      { studentId: number; classroomId?: string; assessedAreaId?: string; sessionId?: string }
    >({
      query: ({ studentId, classroomId, assessedAreaId, sessionId }) => {
        const params = new URLSearchParams();
        if (classroomId) {
          params.append('classroomId', classroomId);
        }
        if (assessedAreaId) {
          params.append('assessedAreaId', assessedAreaId);
        }
        if (sessionId) {
          params.append('sessionId', sessionId);
        }
        return `/academics/students/${studentId}/standards/progress?${params.toString()}`;
      },
      providesTags: ['StudentProgress'],
    }),

    saveStudentProgress: builder.mutation<
      { data: Achievement },
      SaveProgressParams
    >({
      query: ({ studentId, ...body }) => ({
        url: `/academics/students/${studentId}/standards/progress`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['StudentProgress'],
    }),
  }),
});

export const {
  useGetStudentStandardsProgressQuery,
  useSaveStudentProgressMutation,
} = standardsProgressApi;


export interface Level {
  id: number;
  displayName: string;
  value: number;
}

export interface LearningStandard {
  id: number;
  displayName: string;
  classroom?: {
    id: number;
    displayName: string;
  };
  level?: {
    id: number;
    displayName: string;
  };
}

export interface Achievement {
  id: number;
  learningStandard: LearningStandard;
  level: Level | null;
}

export interface StudentProgress {
  student: {
    displayName: string;
    id: number;
  };
  classroom: {
    displayName: string;
    id: number;
  };
  session: {
    displayName: string;
    id: number;
  };
  achievements: Achievement[];
  meta: {
    levels: Level[];
  };
}

export interface SaveProgressParams {
  studentId: number;
  standardId: number;
  levelId: number | null;
  sessionId: string;
  classroomId: string;
  assessedAreaId: string;
}
